module.exports = __webpack_public_path__ + "img/login-img-5.3088949d.svg";